import { useState, useCallback } from 'react';

const useModal = (defaultState = false) => {
  const [isOpen, setIsOpen] = useState(defaultState);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((prevIsOpen) => !prevIsOpen), []);

  return { isOpen, open, close, toggle };
};

export default useModal;
